import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Loader from '@app/components/ui/placeholders/Loader'
import _ from 'lodash'
import * as studentActions from '@app/actions/students'
import { Student } from '@app/models/users'

class TasksContainer extends Component {
  componentDidMount() {
    this.props.boundActions.fetchTasksIfNeeded(this.props.tour)
  }

  render() {
    const { ChildComponent, tasks, tour, loader, event, ...rest } = this.props
    const statistics = tasks[tour]

    if (!statistics) { return null }
    if (statistics.fetching && _.isEmpty(statistics.objects) && loader) {
      return <Loader />
    }

    if (!statistics.fetching && _.isEmpty(statistics.objects)) {
      return null
    }

    return (
      <ChildComponent tour={tour} statistics={statistics} event={event} {...rest} />
    )
  }
}

const mapStateToProps = (state) => {
  const { students: { tasks }, global: { event } } = state;
  return { tasks, event }
}

const mapDispatchToProps = (dispatch) => {
  const boundActions = bindActionCreators(studentActions, dispatch)
  return { boundActions }
}

TasksContainer.propTypes = {
  student: PropTypes.instanceOf(Student).isRequired,
  ChildComponent: PropTypes.any.isRequired,
  tour: PropTypes.string.isRequired,
  loader: PropTypes.bool.isRequired
}

TasksContainer.defaultProps = {
  loader: true
}

export default connect(mapStateToProps, mapDispatchToProps)(TasksContainer)
